import { useEffect, useRef } from 'react';

export interface UseWSChannelOptions<TPayload> {
  enabled?: boolean;
  onMessage: (payload: TPayload) => void;
}

function buildWSUrl(path: string): string {
  const url = new URL(path, window.location.origin);
  url.protocol = url.protocol === 'https:' ? 'wss:' : 'ws:';
  return url.toString();
}

export function useWSChannel<TPayload>(path: string, options: UseWSChannelOptions<TPayload>): void {
  const onMessageRef = useRef(options.onMessage);

  useEffect(() => {
    onMessageRef.current = options.onMessage;
  }, [options.onMessage]);

  useEffect(() => {
    if (options.enabled === false || typeof window === 'undefined') {
      return;
    }

    const socket = new WebSocket(buildWSUrl(path));

    socket.addEventListener('message', (event) => {
      const payload = JSON.parse(String(event.data)) as TPayload;
      onMessageRef.current(payload);
    });

    return () => {
      socket.close();
    };
  }, [options.enabled, path]);
}
